import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";

import { MobilePlatform } from "@state/stores/types";
import { isCapacitorPlatform } from "@utils/specific/capacitor";
import { top } from "safe-area-insets";
import { ErrorMessage } from "@components/inputs/shared";
import { HEADER_HEIGHT } from "@utils/style/constants";

export default observer(function CasinoSearchErrorPopup() {
	const rootStore = useRootAppStore<MobilePlatform>();
	const casinoSearchStore = rootStore.casinoSearchStore;

	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent | TouchEvent) {
			if (
				containerRef.current &&
				!containerRef.current.contains(event.target as Node)
			) {
				casinoSearchStore.setIsErrorOpen(false);
				casinoSearchStore.setIsErrorOpen(false);
			}
		}

		if (casinoSearchStore.isErrorOpen) {
			document.addEventListener("touchstart", handleClickOutside);
		}

		return () => {
			document.removeEventListener("touchstart", handleClickOutside);
		};
	}, [casinoSearchStore.isErrorOpen]);

	const popupPadding = isCapacitorPlatform()
		? { top: top + HEADER_HEIGHT }
		: {};

	return ReactDOM.createPortal(
		<div ref={containerRef} className="popup--search" style={popupPadding}>
			<div className="popup--search__body">
				<ul className="popup--search__list">
					<ErrorMessage
						name={"casinoSearch"}
						customErrorClassName={
							"popup--search__term popup--search__term--error message--validation field-validation-error"
						}
					/>
				</ul>
			</div>
		</div>,
		document.body
	);
});
